/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getFeatureLens} from '../api'

 export const useQueryGetFeatureLens = createReactQueryHook('getFeatureLens', getFeatureLens)
